import gql from 'graphql-tag'
import {useQuery} from '@apollo/client'
import {useGetFiltersData} from './getFiltersData'

const personaSummaryQuery = gql`
  query personaSummary($filters: Filters, $benefits: [BenefitEligibility]) {
    personaSummary(filters: $filters, benefits: $benefits) {
      averageAge
      demographics {
        name
        percentage
      }
      incomeRange
      languages {
        name
        percentage
      }
      outreach {
        name
        percentage
      }
      gender {
        name
        percentage
      }
    }
  }
`

export default function PersonaSummary() {
  const {filtersData, benefitsData} = useGetFiltersData()

  const {
    data: personaSummary,
    loading: loadingPersonaSummary,
    refetch: refetchPersonaSummary,
    error: errorLoadingPersonaSummary
  } = useQuery(personaSummaryQuery, {
    variables: {
      filters: filtersData,
      benefits: benefitsData[0]
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return {personaSummary, loadingPersonaSummary, refetchPersonaSummary, errorLoadingPersonaSummary}
}
